import React from "react";
import { Task, TaskStatusType, getTaskStatus, STATUS_CONFIG } from "../types";

interface StatusBadgeProps {
    task?: Task;
    status?: TaskStatusType;
    size?: "sm" | "md";
    showIcon?: boolean;
    className?: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({
    task,
    status,
    size = "md",
    showIcon = true,
    className = "",
}) => {
    const taskStatus = status || (task ? getTaskStatus(task) : "not-started");
    const config = STATUS_CONFIG[taskStatus];

    const sizeClasses = {
        sm: "px-2 py-0.5 text-xs",
        md: "px-2.5 py-1 text-xs",
    };

    return (
        <span
            className={`inline-flex items-center gap-1.5 ${sizeClasses[size]} rounded-full font-medium ${config.bg} ${config.color} ${className}`}
        >
            {showIcon && <i className={`fas ${config.icon} text-[10px]`} />}
            {config.label}
        </span>
    );
};
